import { Role } from '@/api';
import { useUserInfo } from '@/api/useAuth';

export const usePermission = () => {
  const { data: userInfo } = useUserInfo();

  if (!userInfo) {
    return {
      isMAAdmin: false,
      role: undefined,
    };
  }

  const isMAAdmin = [Role.MA_ADMIN, Role.MA_SUPER_ADMIN].includes(userInfo.user.role);

  return {
    isMAAdmin,
    role: userInfo?.user.role,
  };
};
